export const GetURIByParts = (...args: string[]) => {
  //console.log('args', args);
  return args
    .reduce(
      (acc, element) =>
        acc + (element.slice(-1) == '/' ? element : element + '/'),
      ''
    )
    .slice(0, -1);
};

export const IsJsonString = (stringToParse:string) => {
  try {
    let json = JSON.parse(stringToParse);
    
    return (json && typeof json === "object");
  } catch (e) { }
  
  return false;
}